// extracted by mini-css-extract-plugin
export default {"VolumeControl":"jqXMD","isDragging":"nw2ra","volumeSlider":"hd77a","volumeBar":"A1iKr","volumeBall":"soR7k"};